const discovered = [];

export default class Webtrekk {
    _tracker;
    _trackIndex;

    /**
     * @param {*} tracker - The webtrekk tracker object
     * @param {number} trackIndex - The trackIndex the tracker should start with
     */
    constructor(tracker, trackIndex = -1) {
        this._tracker = tracker;
        this._trackIndex = trackIndex;
    }

    get trackIndex() {
        return this._trackIndex;
    }

    /**
     * track an url or event
     * @param {string} type - The type of track
     * @param {*} payload - The tracking payload
     * @param {number} trackIndex - The index of the track event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    track(type, payload, trackIndex) {
        this._trackIndex = trackIndex;
        if (type === 'event') {
            return this._trackEvent();
        } else if(type === 'page') {
            return this._trackPage(payload.url);
        }
    }

    /**
     * track an url
     * @param {string} url - The url of the page
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackPage(url) {
        // webtrekk always requires the full url in their tracking
        const fullUrl = (/^http/).test(url)
            ? url
            : location.protocol + '//' + location.host + url
        this._tracker.sendinfo({
            contentId: fullUrl,
        });
        return Promise.resolve(true);
    }

    /**
     * track an event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackEvent() {
        //TODO is there event tracking in webtrekk?
        return Promise.resolve(true);
    }

    /**
     * destroy the tracker instance and clean up if necessary
     */
    destroy() {
        this._tracker.setCookie('webtrekkOptOut', 1, 60*60*24*30*12*10);
        this._tracker.deactivatePixel = true;
        this._tracker.optOut = true;
        discovered.length = 0;
    }

    /**
     * repeat calls to this function will not discover the same tracker again
     * @param {number} trackIndex - The trackIndex the tracker should start with
     * @returns - A promise resolving an array of wrapper instances for discovered tracker
     */
    static discover(trackIndex = -1) {
        return new Promise((resolve, reject) => {
            if (!~discovered.indexOf('wt') && window.wt && window.wt.sendinfo) {
                discovered.push("wt");
                resolve([new Webtrekk(window.wt, trackIndex)]);
            } else {
                resolve([])
            }
        });
    }

    /**
     * initialize general purpose things like the tracker's library js
     */
    static init() {
        return Promise.resolve();
    }

    /**
     * @param {*} options - The tracker options 
     * {
     *     trackId: string; //the tracker id
     *     trackDomain: string; //the domain of the tracking endpoint
     *     domain: string; //the domain of the website that should be tracked
     *     ...
     * }
     * @returns - A promise resolving the wrapper instance
     */
    static create(options) {
        return new Promise((resolve, reject) => {
            if (!~discovered.indexOf('wt') && window.webtrekkV3) {
                if (!window.wt) {
                    window.wt = new window.webtrekkV3(options);
                }

                window.wt.setCookie('webtrekkOptOut', 0, -1);
                window.wt.deactivatePixel = false;
                window.wt.optOut = false;

                resolve(new Webtrekk(window.wt));
            } else {
                resolve(null);
            }
        })
    }
}


// WEBPACK FOOTER //
// ./lib/analytics/tracker-webtrekk.js